<template>
  <div class="hint-cont" :style="{minWidth: offset ? offset + '%' : '100%'}">
    <p class="trim-text">
      {{string}}
    </p>

    <span class="btn-hint name-hint btn-hint_bottom" v-if="trimmed">
        {{string}}
      </span>
  </div>
</template>

<script>
  export default {
    props: {
      string: {
        type: String,
      },
      width: {
        type: Number
      },
      offset: {
        type: Number,
        required: false
      }
    },
    name: 'trimItem',
    data() {
      return {
        trimmed: false
      }
    },
    watch: {
      string(val ){
        if (val) {
          this.trimString(val)
        }
      }
    },
    methods: {
      trimString(string) {
        if (string && (string.length > this.width)) {
          string = string.slice(0, this.width - 10) + '...';
          this.trimmed = true
        } else {
          this.trimmed = false
        }
      }
    },
    mounted() {
      this.trimString(this.string)
      setTimeout(() => this.trimString(this.string), 1000)
      setTimeout(() => this.trimString(this.string), 3000)
    }
  }
</script>

<style lang="scss" scoped>
  .trim-text {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    width: 100%;
    min-height: 21px; //без min-height обрезается нижная часть букв
    line-height: 21px;
  }

  .hint-cont {
    //width: calc(100% - 60px);
    min-width: 100%;
    margin-left: 5px;
  }
</style>
<style lang="scss">
//.project-info .info-header-left .bit-title .hint-cont {
//  min-height: 24px;
//  line-height: 24px;
//
//}
</style>
